import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { CONTENT_ROUTES } from './shared/incomeTaxRoutes/content-layout.routes';
import { FULL_ROUTES } from './shared/incomeTaxRoutes/full-layout.routes';

const appRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  { path: 'Auth/login', redirectTo: 'login', pathMatch: 'full'},
  { path: '', component: FullLayoutComponent, data: { title: 'full Views' }, children: FULL_ROUTES},
  { path: '', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES},
  {
    path: '**',
    redirectTo: 'error' 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
